import { OpenLocalButton } from "components/Sidebar/OpenLocalButton";
import { useEnvironmentInterface } from "environment-interface";
import type { Client } from "features/container/types";
import { useFollowChannel } from "hooks/pitcher/useFollowChannel";
import { usePitcherClients } from "hooks/pitcher/usePitcherClients";
import { Box } from "prism-react";

import { ClientsList } from "../ClientsList/ClientsList";
import { PrimaryCTA } from "../PrimaryCTA/PrimaryCTA";
import { ShareButton } from "../ShareButton/ShareButton";
import { Topbar } from "../Topbar/Topbar";

export const TopBarItems = () => {
  const { visibility } = useEnvironmentInterface();
  const followChannel = useFollowChannel();
  const pitcherClients = usePitcherClients();

  const followedClient = followChannel?.state.following.match({
    FOLLOWING: ({ clientId }) => pitcherClients.clients[clientId],
    NOT_FOLLOWING: () => undefined,
  });

  function onClientClick(client: Client) {
    if (!followChannel) return;

    if (followedClient?.clientId === client.clientId) {
      followChannel.unfollow();
    } else {
      followChannel.follow(client.clientId);
    }
  }

  const topbarItems = (
    <>
      {visibility.isInIframe ? null : (
        <>
          <Box css={{ px: "$3" }}>
            <ClientsList
              clients={pitcherClients.clients}
              currentClient={pitcherClients.current}
              followedClient={followedClient}
              onClientClick={onClientClick}
            />
          </Box>
          <OpenLocalButton />
          <ShareButton />
        </>
      )}
      <PrimaryCTA />
    </>
  );

  return <Topbar>{topbarItems}</Topbar>;
};
